module.exports = __webpack_public_path__ + "static/media/logo-cbg-corporate-white.649aba38.svg";